const mutations = {
  candidateRegistration: (state, payload) => {},
  recruiterRegistration: (state, payload) => {},
  industryList: (state, payload) => {
    state.industryList = payload
  },

  showVideoModal: (state, value) => {
    state.showVideoModal = value
  }
}

export default mutations
